import type { DefaultValues } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import type { ILogInFormValues } from '~/components/forms/LogInForm';
import type { IAppRegion } from '~/lib/appSettings';
import { LogInPage } from '~/components/pages/LogInPage';
import { PageTemplate } from '~/components/templates/PageTemplate';

export const LogInRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const nextUrl = searchParams.get('nextUrl') || undefined;
  const email = searchParams.get('email') || undefined;
  const appRegion = (searchParams.get('appRegion') || undefined) as
    | IAppRegion
    | undefined;
  const defaultValues: DefaultValues<ILogInFormValues> = {
    email,
    appRegion,
  };

  return (
    <PageTemplate>
      <LogInPage nextUrl={nextUrl} defaultValues={defaultValues} />
    </PageTemplate>
  );
};
